import { render, staticRenderFns } from "./MakeBrowserTalk.vue?vue&type=template&id=cb1d62d8&scoped=true"
import script from "./MakeBrowserTalk.vue?vue&type=script&lang=js"
export * from "./MakeBrowserTalk.vue?vue&type=script&lang=js"
import style0 from "./MakeBrowserTalk.vue?vue&type=style&index=0&id=cb1d62d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1d62d8",
  null
  
)

export default component.exports